import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./AttachmentsBlock').then(m => ({default: m.AttachmentsBlock})),
)

export const attachmentsBlockInfo = B.blockInfo({...meta, Admin, InnerBlock})
